module.exports = __webpack_public_path__ + "img/Dark Ninja.jpg";